import { ASSET_TYPES } from '~/constants';

export const PER_PAGE = 200;

// The distance in pixels before the end of the items that will trigger a call to loadMore.
export const SCROLL_THRESHOLD = 400;

export const ACTIVE_STATUS = 'active';

export const ACTIVE_ASSET_ID = 'activeAsset';

export const ACTIVE_ASSETS_ID = 'activeAssets';

export const DEFAULT_ASSET_TYPE = 'asset';

export const ASSET_TYPE_SEARCH_PLACEHOLDERS = {
  [ASSET_TYPES.intervention_unit.type]: 'Search Intervention Unit...',
  [ASSET_TYPES.rig.type]: 'Search Rig...',
  [ASSET_TYPES.frac_fleet.type]: 'Search Pad / Frac Fleet...',
};

export const ASSET_TYPE_SEARCH_PLACEHOLDERS_NO_SECONDARY = {
  ...ASSET_TYPE_SEARCH_PLACEHOLDERS,
  [ASSET_TYPES.frac_fleet.type]: 'Search Frac Fleet...',
};
